import { render, staticRenderFns } from "./AddBannerBySliderForm.vue?vue&type=template&id=3758aa97&scoped=true&"
import script from "./AddBannerBySliderForm.vue?vue&type=script&lang=js&"
export * from "./AddBannerBySliderForm.vue?vue&type=script&lang=js&"
import style0 from "./AddBannerBySliderForm.vue?vue&type=style&index=0&id=3758aa97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3758aa97",
  null
  
)

export default component.exports